import some from "lodash/some";
import { DateTime } from "luxon";
import api from "../../services/api";
import { AxiosResponse } from "axios";
import history from "services/history";
import findIndex from "lodash/findIndex";
import apiMongo from "services/api-mongo";
import { IReduxStore } from "interfaces/IReduxStore";
import { call, put, select, takeLatest } from "redux-saga/effects";
import { Creators as authActions } from "../ducks/auth";
import { ICredentials } from "store/interfaces/ICredentials";
import { Creators as alertActions } from "../ducks/alert/index";
import { MigrationUserPayload } from "screens/MigrationUser/types";
import { Creators as lessonPlanActions } from "../ducks/lesson-plan";
import { Creators as courseActions, ICourseState } from "../ducks/course";
import { Creators as credentialsActions, Types } from "../ducks/credentials";

const getCurrentCredentials = (state: IReduxStore) => state.credentials;

function* setCourse(action: { courses: ICourseState[]; shouldPreventRedirect?: boolean }) {
    const { courses, shouldPreventRedirect } = action;

    const firstCourseIsPublishedIndex = findIndex(courses, { isPublished: true });

    api.defaults.headers.common["X-Course"] = courses[firstCourseIsPublishedIndex].slug;

    yield put(courseActions.setCourse({ course: courses[firstCourseIsPublishedIndex], shouldPreventRedirect }));
}

function* redirectUser(action: { data: ICredentials; shouldPreventRedirect?: boolean }) {
    try {
        const { data, shouldPreventRedirect } = action;

        const hasPublishedCourses = some(data.courses, { isPublished: true });

        if (!hasPublishedCourses) {
            const courseSlug = yield select((state: IReduxStore) => state.course.slug);
            return yield call(history.push, { pathname: `/app/curso/${courseSlug}/materias` });
        }

        yield call(setCourse, { courses: data.courses, shouldPreventRedirect });

        yield put(lessonPlanActions.getLessonPlanRequest());
    } catch (error) {
        console.log("error redirect", error);
    }
}

function* getCredentials(action: any) {
    try {
        const { data }: AxiosResponse<ICredentials> = yield call(api.get, "/person/me");

        yield put(credentialsActions.getCredentialsSuccess(data));

        yield call(redirectUser, { data, shouldPreventRedirect: !!action?.payload?.shouldPreventRedirect });
    } catch (error) {
        console.log("error", JSON.stringify(error));
        yield put(alertActions.showAlert(error.message, "danger"));
        yield put(credentialsActions.getCredentialsFailure());
    }
}

function* migrationUser(action: { type: string; payload: MigrationUserPayload }) {
    try {
        const { payload } = action;

        const formatted = {
            ...payload.step1,
            ...payload.step3,
            ...(payload.step2 && {
                address: [payload.step2]
            }),
            birthDate: DateTime.fromFormat(payload.step1?.birthDate!, "dd/LL/yyyy").toFormat("yyyy-LL-dd")
        };

        const { data } = yield call(api.post, "/person/migrate", formatted);
        const { credentials: updatedCredentials, ...rest } = data;

        yield put(credentialsActions.migrateUserSuccess());

        api.defaults.headers.common["Authorization"] = yield `Bearer ${data.token}`;
        apiMongo.defaults.headers.common["Authorization"] = yield `Bearer ${data.token}`;

        yield put(
            authActions.loginSuccess({
                ...rest,
                refresh_token: rest.refresh_token
            })
        );

        const credentials = yield select(getCurrentCredentials);

        const newCredentials = {
            ...credentials,
            ...updatedCredentials,
            isTermsAccepted: true
        };

        yield put(credentialsActions.getCredentialsSuccess(newCredentials));

        yield call(setCourse, { courses: newCredentials.courses });
    } catch (error) {
        console.log("error", error);
        yield put(credentialsActions.migrateUserFailure({ error: "Ocorreu um erro ao tentar fazer a atualização. Tente novamente." }));
    }
}

export default [takeLatest(Types.GET_CREDENTIALS_REQUEST, getCredentials), takeLatest(Types.MIGRATE_USER_REQUEST, migrationUser)];
